var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrophone = function SvgMicrophone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2878_63392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.195a3.407 3.407 0 0 1-3.403-3.403V6.028a3.403 3.403 0 0 1 6.806 0v4.764a3.407 3.407 0 0 1-3.403 3.403m6.125-3.403a.68.68 0 0 0-1.361 0 4.764 4.764 0 0 1-9.528 0 .68.68 0 0 0-1.361 0 6.125 6.125 0 1 0 12.25 0m-5.445 7.486v-2.042a.68.68 0 0 0-1.361 0v2.042a.68.68 0 0 0 1.361 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2878_63392"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.375 2.625h12.25v16.334H4.375z"
  })))));
};
export default SvgMicrophone;